<template>
  <div class="userAgent-page">
    <h1 class="page-title">Agents</h1>
    <b-col xs="12">
      <Widget
          title="<h5>Listed <span class='fw-semi-bold'>Agents</span></h5>"
          bodyClass="widget-table-overflow"
          customHeader>
        <div class="table-responsive">
          <table class="table table-lg mb-0 requests-table">
            <thead>
            <tr class="text-muted">
              <th>MOBILE</th>
              <th>BALANCE</th>
              <th>PENDING AMOUNT</th>
              <th>Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="agent in agents"
                :key="agent.id"
            >
              <td>{{ agent.mobile }}</td>
              <td>{{ agent.balance }}</td>
              <td>{{ agent.pending_amount }}</td>
              <td>
                <router-link :to="{name: 'agentDetails', query: { id: agent.id }}"
                             class="btn btn-success btn-xs p-1 px-3">Details
                </router-link>
                <b-button @click="selectAgentForPayment(agent)"
                          variant="success"
                          class="ml-1 p-1 px-3 btn-xs">
                  make payment

                  <b-modal v-model="showPaymentModal" centered title="Ekhoni Daktar" @ok="makePayment">
                    <h4 v-if="selectedAgent" class="text-center">{{ selectedAgent.mobile }}</h4>
                    <b-row>
                      <b-col>
                        <label>Pending Amount :<h4 v-if="selectedAgent">{{ selectedAgent.pending_amount }}</h4></label>
                      </b-col>
                      <b-col>
                        <!--            post_grad-->
                        <b-form-group id="amount_group" label="Amount * :" label-for="amount"
                                      description="Enter Amount to be paid">
                          <b-form-input id="amount" v-model="payment_form.amount" required type="number"
                                        placeholder="Amount"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-form-group id="additional_info_group" label="Additional Info * :" label-for="additional_info">
                      <b-form-input id="additional_info" v-model="payment_form.additional_info" required type="text"
                                    placeholder="Additional Info"></b-form-input>
                    </b-form-group>

                  </b-modal>

                </b-button>

                <b-button variant="danger"
                          class="ml-1 p-1 px-3 btn-xs"
                          @click="selectAgentForRemoval(agent)"
                >
                  remove
                  <b-modal v-model="showAgentRemoveModal" centered title="Remove Agent" hide-footer>
                    <h4 v-if="selectedAgent" class="text-center">{{ selectedAgent.mobile }}</h4>
                    <b-row>
                      <b-col>
                        <label>Clear out pending amount before removing agent</label>
                        <label>Pending Amount :<h4 v-if="selectedAgent">{{ selectedAgent.pending_amount }}</h4></label>
                      </b-col>
                    </b-row>
                    <b-btn variant="danger" @click="removeAgent">remove</b-btn>
                  </b-modal>

                </b-button>

              </td>
              <!--              <td>{{ agents.is_agent }}</td>-->
            </tr>
            </tbody>
          </table>
        </div>
      </Widget>
    </b-col>
  </div>
</template>

<script>
import Widget from "../../../components/admin/Widget/Widget";
import UserService from "@/services/admin/user.service";
import {Form} from "vform";
import moment from "moment";
import DoctorService from "@/services/admin/doctor.service";

export default {
  name: 'UserAgents',
  components: {
    Widget,
  },
  data() {
    return {
      showPaymentModal: false,
      showAgentRemoveModal: false,
      selectedAgent: null,
      agents: [],
      agentRemoveForm: new Form({
        'is_agent': 0,
        'agent_percentage': 0
      }),
      payment_form: new Form({
        amount: null,
        doctor_id: null,
        additional_info: null,
        date: null,
      }),
    };
  },
  methods: {
    selectAgentForPayment(agent) {
      this.selectedAgent = agent;
      this.showPaymentModal = true;
    },

    selectAgentForRemoval(agent) {
      this.selectedAgent = agent;
      this.showAgentRemoveModal = true;
    },

    loadAgents() {
      UserService.fetchUsers(1)
          .then((response) => {
            if (response.status === 200) {
              this.agents = response.data.data;
            }
          })
    },

    removeAgent() {
      UserService.convertAgentStatus(this.selectedAgent.id, this.agentRemoveForm)
          .then((response) => {
            if (response.status === 204) {
              this.showAgentRemoveModal = false;
              this.loadAgents();
            }
          })

    },

    makePayment() {
      let date = new Date();
      this.payment_form.date = moment(String(date)).format("YYYY-MM-DDTHH:mm:ss.SZ");
      if (this.payment_form.amount <= this.selectedAgent.pending_amount) {
        DoctorService.makePayment(this.payment_form)
            .then((response) => {
              if (response.status === 201) {
                this.showPaymentModal = false;
                this.loadAgents();
              }
            })
      } else {
        alert('Amount must be less or equal to pending amount');
      }
    },

  },
  mounted() {
    this.loadAgents();
  }
};
</script>

<style src="./UserAgents.scss" lang="scss"/>
